import type { Paginated, PaginationQuery } from "@/configs/request";
import type { SentMessage } from "@/types";

import { BaseApi } from "./base.api";

export type AnnouncementAudience = "all" | "hosts";

export interface SentMessageFilter extends PaginationQuery {
  type?: "admin_message" | "admin_announcement";
}

/**
 * Moderator xabarlari va e'lonlar.
 *
 * Platforma foydalanuvchi bilan gaplasha olmasdi: murojaatga javob
 * berish, xizmat to'xtashi haqida ogohlantirish, qoida o'zgarganini
 * aytish — hech biri uchun yo'l yo'q edi.
 */
class AdminMessagesApi extends BaseApi {
  sent(filter: SentMessageFilter = {}) {
    return this.request<Paginated<SentMessage>>("/admin/messages", { query: { ...filter } });
  }

  /**
   * Bitta odamga.
   *
   * Matn TARJIMA QILINMAYDI va foydalanuvchiga aynan shu holida
   * ko'rinadi — uning tilini bilib yozish moderatorning ishi.
   */
  toUser(userId: string, text: string) {
    return this.request<void>("/admin/messages/user", {
      method: "POST",
      body: { userId, text },
    });
  }

  /** Hammaga. Alohida ruxsat: `notifications.announce`. */
  announce(audience: AnnouncementAudience, text: string) {
    return this.request<{ sent: number }>("/admin/messages/announce", {
      method: "POST",
      body: { audience, text },
    });
  }
}

export const adminMessagesApi = new AdminMessagesApi();
